import { StatusSolicitacaoModel } from "./StatusSolicitacaoModel";

export { SolicitacaoSemPrestadorModel } from "./SolicitacaoSemPrestadorModel";
export { FiltroServicosSemPrestadorModel } from "./FiltroServicosSemPrestadorModel";
export { FiltroServicosModel } from "./FiltroServicosModel";
export { SolicitacaoModel } from "./SolicitacaoModel";
export { StatusSolicitacaoModel } from "./StatusSolicitacaoModel";
export { ContatoModel } from "./ContatoModel";
export { EnderecoModel } from "./EnderecoModel";
export { LocalizacaoModel } from "./LocalizacaoModel";
export { VeiculoModel } from "./VeiculoModel";
export { TransportePessoasModel } from "./TransportePessoasModel";
export { ServicoDetalhadoModel } from "./ServicoDetalhadoModel";
export { ServicoDetalhado } from "./ServicoDetalhado";
export { FinalizarSolicitacaoModel } from "./FinalizarSolicitacaoModel";
export { DadosClienteModel } from "./DadosClienteModel";
export { DadosCliente } from "./DadosCliente";
export { tipoServicoList } from "./TipoServicoModel";

export const statusList: StatusSolicitacaoModel[] = [
  { valor: ["AGUARDANDO"], descricao: "Aguardando aceitação" },
  { valor: ["ACEITO"], descricao: "Solicitação em andamento"},
  { valor: ["FINALIZADO"], descricao: "Serviço realizado" },
  { valor: ["RECUSADO"], descricao: "Recusado"},
  { valor: ["TEMPO_ESGOTADO", "NAO_ATENDIDO", "CANCELADO"], descricao: "Não atendido" },
], statusListPlural: StatusSolicitacaoModel[] = [  
  { valor: ["AGUARDANDO"], descricao: "Aguardando aceitação" },
  { valor: ["ACEITO"], descricao: "Solicitações em andamento"},
  { valor: ["FINALIZADO"], descricao: "Serviços realizados" },
  { valor: ["RECUSADO"], descricao: "Recusados"},
  { valor: ["TEMPO_ESGOTADO", "NAO_ATENDIDO", "CANCELADO"], descricao: "Não atendidos" },
  { valor: ["PENDENTE_PAGAMENTO"], descricao: "Aguardando Pagamento"},
], statusListServico: StatusSolicitacaoModel[] = [  
  { valor: ["PENDENTE_PAGAMENTO"], descricao: "Aguardando pagamento"},
];